import { render } from "./SolicitudReunionView.vue?vue&type=template&id=0d9a4a16&ts=true"
import script from "./SolicitudReunionView.vue?vue&type=script&lang=ts"
export * from "./SolicitudReunionView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__